import http from "../http-common";

export type CouponType = 'GENERAL' | 'QUANTITY' | 'SPECIFIC' | 'EXPIRATION'

export type CouponModel = {
    id: number
    code: string
    type: string
    quantity: number
    value: string
    percentage: number
    expiration_date: Date
    user_name: number
    usages: number
    enabled: boolean
    actions?: any
}

export type CouponRequestModel = {
    code: string;
    type: CouponType;
    value?: number|undefined;
    userId?: number|undefined;
    quantity?: number|undefined;
    percentage?: string|undefined;
    expirationDate?: string;
}

export type CouponFilter = {
    page: number,
    size: number,
    search?: string
}

export type CouponVeriy = {
    code: string,
    planId: number
}

export const getCouponPaginated = (filter: CouponFilter) => {
    let request = `/coupon?`
    if (filter.search !== undefined) request = request + `search=${encodeURIComponent(filter.search)}&`
    request = request + `size=${filter.size}&page=${filter.page}`
    return http.get(request)
}

export const saveCoupon = (coupon: CouponRequestModel) => http.post('/coupon', coupon)

export const updateCoupon = (id: number, coupon: CouponRequestModel) => http.put(`/coupon/${id}`, coupon)

export type CouponVerifyResponse = {
    value?: string,
    percentage?: string,
    planValue: string,
    discount?: string
}
export const verifyCoupon = (coupon: CouponVeriy) => {
    return http.post<CouponVerifyResponse>('/coupon/verify', coupon)
}

export const switchCoupon = (coupon: CouponModel) => {
    let url = `/coupon`
    if (coupon.enabled) url = url + `/disable/${coupon.id}`
    else url = url + `/enable/${coupon.id}`
    return http.put(url)
}
